import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import SwitchButton from 'modules/project_management/components/SwitchButton'
import {
  ScheduleVisibilityOptions,
  useScheduleVisibilityOptions,
} from 'modules/project_management/contexts/ScheduleVisibilyOptionsContext'

const VisibilityPopoverContent = () => {
  const { visibilityOptions, updateVisibilityOptions } = useScheduleVisibilityOptions()
  const { showAvatar, showRole, showPlanningHours, showAgreementHours } = visibilityOptions

  const onChange = (key: keyof ScheduleVisibilityOptions) => {
    updateVisibilityOptions(key, !visibilityOptions[key])
  }

  return (
    <Box padding="s16">
      <Box background="grey100">
        <Box paddingBottom="s12" paddingX="s16" paddingTop="s16">
          <Text className="text-f1-foreground-secondary" weight="medium" size="100">
            {i18n.t('project_management.schedule.visibility_popover.title').toUpperCase()}
          </Text>
        </Box>
        <Box paddingBottom="s16" paddingX="s16" paddingTop="s8" gap="s16">
          <SwitchButton
            onChange={() => onChange('showAvatar')}
            checked={showAvatar}
            id="showAvatar"
            title={i18n.t('project_management.schedule.visibility_popover.avatar')}
          />
          <SwitchButton
            onChange={() => onChange('showRole')}
            checked={showRole}
            id="showRole"
            title={i18n.t('project_management.schedule.visibility_popover.role')}
          />
          <SwitchButton
            onChange={() => onChange('showPlanningHours')}
            checked={showPlanningHours}
            id="showPlanningHours"
            title={i18n.t('project_management.schedule.visibility_popover.planning_hours')}
          />

          <SwitchButton
            onChange={() => onChange('showAgreementHours')}
            checked={showAgreementHours}
            id="showAgreementHours"
            title={i18n.t('project_management.schedule.visibility_popover.agreement_hours')}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default VisibilityPopoverContent
